import { render, staticRenderFns } from "./ContractRegisterPage.vue?vue&type=template&id=3a2ad61a&scoped=true"
import script from "./ContractRegisterPage.vue?vue&type=script&lang=js"
export * from "./ContractRegisterPage.vue?vue&type=script&lang=js"
import style0 from "./ContractRegisterPage.vue?vue&type=style&index=0&id=3a2ad61a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2ad61a",
  null
  
)

export default component.exports